/** Allow only http(s) booking URLs. Reject javascript: and other schemes. */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.toString();
  } catch {
    return null;
  }
  return null;
}

export function normalizeBookingUrl(value: unknown): string | null {
  if (value == null || value === '') return null;
  return safeHttpUrl(String(value));
}

export function reserveLabel(kind?: string): string {
  return kind === 'rest_suite' ? 'Reserve' : 'Book';
}
